/**
 * AI Features - Vanilla JS para Olist/Vnda
 * Reproduz o comportamento do componente React original
 * (auto-rotation, progress bar, scroll snap, fade transitions)
 */

(function() {
  'use strict';

  var AIFeatures = function(section) { 
    this.section = section;
    this.currentFeature = 0;
    this.progressInterval = null;
    this.isAutoPlaying = false;
    this.features = [];
    this.images = [];
    this.featuresList = null;

    this.init();
  };

  AIFeatures.prototype.init = function() {
    this.featuresList = this.section.querySelector('[data-features-list]');
    this.featureItems = Array.prototype.slice.call(
      this.section.querySelectorAll('[data-feature-index]')
    );
    this.imageContainers = Array.prototype.slice.call(
      this.section.querySelectorAll('[data-image-index]')
    );

    if (!this.featureItems.length) return;

    // Bind click events
    var self = this;
    this.featureItems.forEach(function(item, index) {
      item.addEventListener('click', function() {
        self.handleFeatureClick(index);
      });
    });

    // Start auto-rotation
    this.startAutoPlay();

    // Pause on tab hidden
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        self.pauseAutoPlay();
      } else {
        self.startAutoPlay();
      }
    });

    // Handle resize
    window.addEventListener('resize', this.debounce(function() {
      self.scrollToActiveFeature();
    }, 150));
  };

  AIFeatures.prototype.handleFeatureClick = function(index) {
    if (index === this.currentFeature) return;

    this.currentFeature = index;
    this.resetProgressBars();
    this.updateActiveFeature();
    this.scrollToActiveFeature();

    // Pause briefly on manual interaction, then resume
    this.pauseAutoPlay();
    var self = this;
    setTimeout(function() {
      self.startAutoPlay();
    }, 5000);
  };

  AIFeatures.prototype.updateActiveFeature = function() {
    var self = this;

    // Update feature items
    this.featureItems.forEach(function(item, index) {
      var isActive = index === self.currentFeature;
      item.classList.toggle('is-active', isActive);

      // Reset progress animation
      var progressBar = item.querySelector('[data-progress-bar]');
      if (progressBar) {
        progressBar.style.animation = 'none';
        // Force reflow
        void progressBar.offsetHeight;
        if (isActive) {
          progressBar.style.animation = 'af-progress-fill 6s linear forwards';
        }
      }
    });

    // Update images
    this.imageContainers.forEach(function(container, index) {
      container.classList.toggle('is-visible', index === self.currentFeature);
    });
  };

  AIFeatures.prototype.scrollToActiveFeature = function() {
    if (window.innerWidth >= 1024) return;

    var activeItem = this.featureItems[this.currentFeature];
    var container = this.featuresList;

    if (!activeItem || !container) return;

    var containerRect = container.getBoundingClientRect();
    var itemRect = activeItem.getBoundingClientRect();
    var scrollLeft = activeItem.offsetLeft - (containerRect.width - itemRect.width) / 2;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };

  AIFeatures.prototype.startAutoPlay = function() {
    if (this.progressInterval) return;

    this.isAutoPlaying = true;
    var self = this;

    // 6 seconds total = 60 steps de 100ms
    this.progressInterval = setInterval(function() {
      self.currentFeature = (self.currentFeature + 1) % self.featureItems.length;
      self.resetProgressBars();
      self.updateActiveFeature();
      self.scrollToActiveFeature();
    }, 6000);
  };

  AIFeatures.prototype.pauseAutoPlay = function() {
    this.isAutoPlaying = false;
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  };

  AIFeatures.prototype.resetProgressBars = function() {
    this.featureItems.forEach(function(item) {
      var bar = item.querySelector('[data-progress-bar]');
      if (bar) {
        bar.style.animation = 'none';
        void bar.offsetHeight; // Force reflow
      }
    });
  };

  AIFeatures.prototype.debounce = function(fn, wait) {
    var timeout;
    return function() {
      var args = arguments;
      var self = this;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(self, args);
      }, wait);
    };
  };

  // Initialize all sections on page
  function initAIFeatures() {
    var sections = document.querySelectorAll('[data-ai-features]');
    Array.prototype.forEach.call(sections, function(section) {
      if (section._aiFeatures) return;
      section._aiFeatures = new AIFeatures(section);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAIFeatures);
  } else {
    initAIFeatures();
  }
})();